import { render, staticRenderFns } from "./team-player-events.vue?vue&type=template&id=a1a323b0&scoped=true&"
import script from "./team-player-events.vue?vue&type=script&lang=js&"
export * from "./team-player-events.vue?vue&type=script&lang=js&"
import style0 from "./team-player-events.vue?vue&type=style&index=0&id=a1a323b0&prod&lang=css&"
import style1 from "./team-player-events.vue?vue&type=style&index=1&id=a1a323b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a323b0",
  null
  
)

export default component.exports